import {
  GetStatisticsMembersByPeriodResponse,
  GetStatisticMembersSummaryByPeriodResponse,
  GetStatisticsMembersByPeriodRequest,
  GetMembersJoinConfigRequest,
  GetMembersJoinConfigResponse
} from 'supporter';

import {DateType, MemberStatisticState} from '@/types/memberStatistic';

import {ActionContext} from 'vuex';
import {api} from '@/api';

export default {
  namespaced: true,
  state: {
    query: {
      mallName: 'name',
      dateType: 'PERIOD',
      retStartYmd: '0000-00-00',
      retEndYmd: '0000-00-00',
      retYear: '0000',
      retMonth: '00'
    },
    queryOption: {
      page: 1,
      pageSize: 30,
      totalCount: 0
    },

    membersJoinConfigResponse: {},
    statisticMembersSummaryByPeriodResponse: {},
    statisticMembersByPeriodResponse: {}
  },
  actions: {
    async fetchMemberJoinConfig({commit}: ActionContext<MemberStatisticState, any>, params: GetMembersJoinConfigRequest): Promise<any> {
      api.getMemberJoinConfig(params).then((res): void => {
        commit('SET_JOIN_CONFIG_DATA', res.data);
      });
    },
    async fetchStatisticMembersSummaryByPeriod({commit}: ActionContext<MemberStatisticState, any>, params: GetStatisticsMembersByPeriodRequest): Promise<any> {
      api.getStatisticMembersSummaryByPeriod(params).then((res): void => {
        commit('SET_SUMMARY_DATA', res.data);
      });
    },
    async getStatisticsMembersByPeriod({commit}: ActionContext<MemberStatisticState, any>, params: any): Promise<any> {
      api.getStatisticsMembersByPeriod(params).then((res): void => {
        commit('SET_MEMBERS_DATA', res.data);
        commit('SET_PERIOD_COUNT', res.data.totalCount);
      });
    }
  },
  mutations: {
    SET_MALL_NAME(state: MemberStatisticState, changeMall: string): void {
      state.query.mallName = changeMall;
    },
    SET_DATE_TYPE(state: MemberStatisticState, changeType: DateType): void {
      state.query.dateType = changeType;
    },
    SET_START_YMD(state: MemberStatisticState, changeYmd: string): void {
      state.query.retStartYmd = changeYmd;
    },
    SET_END_YMD(state: MemberStatisticState, changeYmd: string): void {
      state.query.retEndYmd = changeYmd;
    },
    SET_YEAR(state: MemberStatisticState, year: string): void {
      state.query.retYear = year;
    },
    SET_MONTH(state: MemberStatisticState, month: string): void {
      state.query.retMonth = month;
    },
    SET_PAGE(state: MemberStatisticState, page = 1): void {
      state.queryOption.page = page;
    },
    SET_PAGE_SIZE(state: MemberStatisticState, pageSize = 30): void {
      state.queryOption.pageSize = pageSize;
    },
    SET_JOIN_CONFIG_DATA(state: MemberStatisticState, response: GetMembersJoinConfigResponse): void {
      state.membersJoinConfigResponse = response;
    },
    SET_SUMMARY_DATA(state: MemberStatisticState, response: GetStatisticMembersSummaryByPeriodResponse): void {
      state.statisticMembersSummaryByPeriodResponse = response;
    },
    SET_MEMBERS_DATA(state: MemberStatisticState, response: GetStatisticsMembersByPeriodResponse): void {
      state.statisticMembersByPeriodResponse = response;
    },
    SET_PERIOD_COUNT(state: MemberStatisticState, response: number): void {
      state.queryOption.totalCount = response;
    }
  },
  getters: {
    providers(state: MemberStatisticState): string[] {
      const providers = ['ALL'];
      if (state.membersJoinConfigResponse.usedMallMember) {
        providers.push('MALL');
      }
      if (state.membersJoinConfigResponse.syncIdProviders) {
        state.membersJoinConfigResponse.syncIdProviders.forEach((provider: any): void => {
          providers.push(provider);
        });
      }
      return providers;
    },
    syncIdProviders(state: MemberStatisticState): string[] {
      return state.membersJoinConfigResponse.syncIdProviders;
    }
  }
};
